<div class="page-cont col-12">
  <div class="title-cont">
    <h4 class="title-h4-blue">{{ title }}</h4>
    <div class="exportar-cont">
      <app-exportar
        [data]="insuranceData"
        (exportar)="onExportar($event)"
      ></app-exportar>
    </div>
  </div>
  <hr />
  <div class="campos-cont">
    <app-campos
      [tipo]="'reclamos'"
      [camposVisibles]="['desde', 'hasta', 'ramo', 'subramo', 'selectFilter']"
      [camposObligatorios]="['desde', 'hasta']"
      (filterChange)="onFilterChange($event)"
      [sLobName]="getSlobName()"
      [lobName]="getLobName()"
      [rangeInMonths]="3"
      [opcionesSelectFilter]="opcionesSelectFilter"
    ></app-campos>
  </div>
</div>

<app-insurance-table
  [data]="insuranceData"
  [config]="tableConfig"
  [configExport]="tableConfigExport || tableConfig"
  [mensajeNoData]="mensajeNoData"
  [error]="errorStatus"
  [itemsPerPage]="pageSize"
  [serverSidePagination]="true"
  [totalRecordsFromServer]="totalRecordsFromServer"
  [totalPagesFromServer]="totalPagesFromServer"
  [totals]="tableTotals"
  [fechaCorte]="fechaCorte"
  (pageChange)="onPageChange($event)"
  (actionClick)="onPrintOrder($event)"
  (loadOrders)="loadOrders($event)"
></app-insurance-table>

@if(isFoundPrint) {
<div class="request-notification-modal">
  <div class="modal-container">
    <img src="assets/warning.svg" alt="warning icon" />
    <h3 class="mb-4">
      <strong>Documentos no disponibles</strong>
    </h3>
    <p>No existen documentos disponibles para el reclamo seleccionado.</p>
    <button (click)="isFoundPrint = false" class="btn-m-new mt-3">
      Cerrar
    </button>
  </div>
</div>
}
